import { useAxios } from '../utils/axiosConfig';
import config from '../contexts/ConfigContext'
import { MenuModel } from "@launchmetrics/dmr-header-component/src/Model/header-models";


class MenuService {
    axios = useAxios();
    async GetMenu(): Promise<MenuModel[]> {
        try {
            const response = await this.axios.get(`${config.API_URL}/api/Permissions/GetMyMenu`);
            return response.data;
        } catch (error) {
            // Handle error
            console.error('Error fetching menu:', error);
            throw error;
        }
    }
}

export default MenuService;

